<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>Baby at His Door</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="9781459206557.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;">Contents</h2>
<div class="contentsEntry" id="contentsEntry4" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/9781459206557_chapter01#chapter01">Chapter One</a></p></div>
<div class="contentsEntry" id="contentsEntry5" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter02#chapter02" title="Link target outside of Sample">Chapter Two</span></p></div>
<div class="contentsEntry" id="contentsEntry6" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter03#chapter03" title="Link target outside of Sample">Chapter Three</span></p></div>
<div class="contentsEntry" id="contentsEntry7" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter04#chapter04" title="Link target outside of Sample">Chapter Four</span></p></div>
<div class="contentsEntry" id="contentsEntry8" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter05#chapter05" title="Link target outside of Sample">Chapter Five</span></p></div>
<div class="contentsEntry" id="contentsEntry9" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter06#chapter06" title="Link target outside of Sample">Chapter Six</span></p></div>
<div class="contentsEntry" id="contentsEntry10" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter07#chapter07" title="Link target outside of Sample">Chapter Seven</span></p></div>
<div class="contentsEntry" id="contentsEntry11" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter08#chapter08" title="Link target outside of Sample">Chapter Eight</span></p></div>
<div class="contentsEntry" id="contentsEntry12" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter09#chapter09" title="Link target outside of Sample">Chapter Nine</span></p></div>
<div class="contentsEntry" id="contentsEntry13" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter10#chapter10" title="Link target outside of Sample">Chapter Ten</span></p></div>
<div class="contentsEntry" id="contentsEntry14" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter11#chapter11" title="Link target outside of Sample">Chapter Eleven</span></p></div>
<div class="contentsEntry" id="contentsEntry15" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter12#chapter12" title="Link target outside of Sample">Chapter Twelve</span></p></div>
<div class="contentsEntry" id="contentsEntry16" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_chapter13#chapter13" title="Link target outside of Sample">Chapter Thirteen</span></p></div>
<div class="contentsEntry" id="contentsEntry17" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781459206557_epilogue#epilogue" title="Link target outside of Sample">Epilogue</span></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459206557_con01.vue?013b31a8